import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RoleSwitchersComponent } from './component/role-switchers/role-switchers.component';

@NgModule({
  declarations: [],
  imports: [CommonModule, RoleSwitchersComponent],
  exports: [RoleSwitchersComponent],
})
export class AuthenticationUiModule {}
